/*
 * @Description:支付管理-补贴油款钱包
 * @Author: WangYuhan
 * @Date: 2022-12-09 17:54:05
 * @LastEditTime: 2023-08-23 14:43:51
 * @LastEditors: WangYuhan
 */
// 引入api请求方法
import { driverTypes } from '@/utils/dictionary/freight';
import { exportExcelTemplate } from '@/api/waybill';
import {
  oilTranChangeList,
  oilTranChangeListCount,
  oilDict,
  oilTranChangeListExportForLs,
} from '@/api/freight';
import { getDriverList } from '@/api/capacity';

const storeModuleName = 'paySubsidyModule';
const state = {
  // 筛选项-
  parameters: [
    {
      style: 'input',
      value: '',
      label: '司机名称',
      placeholder: '请输入姓名/手机号',
      clearable: true,
      param: 'driverName',
    },
    // {
    //   style: 'select',
    //   param: 'driverName',
    //   value: '',
    //   valueType: 'string',
    //   state: 'driverList',
    //   label: '司机名称',
    //   placeholder: '请输入姓名/手机号',
    //   noMatchText: '无匹配请输入',
    //   clearable: true,
    //   filterable: true,
    //   path: `${storeModuleName}/getAllDriverList`,
    // },
    {
      style: 'select',
      param: 'businessId',
      isFixed: true,
      value: '',
      valueType: 'string',
      state: 'companyList',
      label: '企业',
      placeholder: '请选择',
      noMatchText: '无匹配企业',
      clearable: true,
      filterable: false,
      path: `${storeModuleName}/getCompanyList`,
    },
    {
      style: 'select',
      param: 'driverProperty',
      value: '',
      valueType: 'string',
      state: 'driverTypes',
      label: '司机类型',
      placeholder: '请选择',
      clearable: true,
      filterable: false,
      multiple: false,
    },
    {
      style: 'date-picker',
      param: 'insertTime',
      value: [],
      valueType: 'date',
      label: '变动时间',
      placeholder: '请选择',
      type: 'daterange',
      format: 'MM-dd',
      valueFormat: 'yyyy-MM-dd',
      clearable: true,
      params: ['payTimeStart', 'payTimeEnd'],
    },
    {
      style: 'select',
      param: 'applyType',
      value: '',
      valueType: 'string',
      state: 'oilDictList',
      label: '变动类型',
      placeholder: '请选择',
      clearable: true,
      filterable: false,
      multiple: false,
      path: `${storeModuleName}/getoilDict`,
    },
    {
      style: 'input',
      value: '',
      label: '运单编号',
      placeholder: '请输入',
      clearable: true,
      param: 'waybillNo',
    },
  ],
  // 导出
  isExport: {
    isShow: true,
    method: 'get',
    url: oilTranChangeListExportForLs,
  },
  // 页码 + 参数
  postParams: {
    page: 1,
    size: 20,
  },
  // 列表data数据
  listData: {
    list: [],
    tableHeadList: [
      {
        label: '司机信息',
        prop: 'driverName',
        width: 200,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-driverName',
      },
      {
        label: '企业名称',
        prop: 'businessId',
        width: 200,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-businessId',
      },
      {
        label: '变动金额（元）',
        prop: 'amount',
        width: 180,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-amount',
      },
      {
        label: '变动类型',
        prop: 'applyType',
        width: 100,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-applyType',
      },
      {
        label: '变动时间',
        prop: 'payTime',
        width: 200,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-payTime',
      },
    ],
    total: 0,
  },
  payStatusList: [], // 支付状态统计
  companyList: [], // 企业列表
  driverList: [],
  oilDictList: [],
  oilCount: {},
  companyInfo: '', // 当前选中的企业信息
  driverTypes, // 司机类型
  //   alterationTypes, // 变动类型
};

// getters
const getters = {};

// actions
const actions = {
  // 获取列表数据
  getList: async context => {
    const params = {};
    context.state.parameters.forEach(item => {
      if (item.style !== 'date-picker' && item.value) {
        if (item.multiple && item.value === 'string') {
          params[item.param] = item.value.toString();
        } else {
          params[item.param] = item.value;
        }
      }
      if (item.style === 'date-picker' && item.value.length > 0) {
        params[item.params[0]] = `${item.value[0]} 00:00:00`;
        params[item.params[1]] = `${item.value[1]} 23:59:59`;
      }
    });

    // 获取统计信息

    context.dispatch('getStatistics');
    const { data } = await oilTranChangeList(
      Object.assign({}, params, context.state.postParams, { oilSeparation: 'ls' }),
    );
    context.commit('updateState', {
      key: 'listData',
      value: Object.assign({}, context.state.listData, { list: data.records, total: data.total }),
    });

    return data.records;
  },
  // oilTranChangeList
  getStatistics: async context => {
    const params = {};
    context.state.parameters.forEach(item => {
      if (item.style !== 'date-picker' && item.value) {
        if (item.multiple && item.value === 'string') {
          params[item.param] = item.value.toString();
        } else {
          params[item.param] = item.value;
        }
      }
      if (item.style === 'date-picker' && item.value.length > 0) {
        params[item.params[0]] = `${item.value[0]} 00:00:00`;
        params[item.params[1]] = `${item.value[1]} 23:59:59`;
      }
    });
    const { data } = await oilTranChangeListCount(
      Object.assign({}, params, { oilSeparation: 'ls' }),
    );
    context.commit('updateState', {
      key: 'oilCount',
      value: data,
    });
  },
  // 获取企业列表
  getCompanyList: async (context, payload) => {
    const data = JSON.parse(localStorage.getItem('group'));
    if (data && data.id) {
      // 只展示实名认证的企业列表
      const list = data.corporations.filter(item => item.realNameAudit === 1);
      if (list.length) {
        list.forEach(item => {
          item.label = item.principalPartName;
          item.value = item.businessId;
        });
      }
      context.commit('updateState', {
        key: 'companyList',
        value: list,
      });
    }
  },
  getoilDict: async (context, payload) => {
    const { code, data } = await oilDict({
      type: 1,
    });
    if (code === 200) {
      if (data && data.length) {
        data.forEach(item => {
          item.label = item.name;
          item.value = item.code;
        });
      }
      context.commit('updateState', {
        key: 'oilDictList',
        value: data,
      });
    }
  },
  getAllDriverList: async (context, payload) => {
    const { code, data } = await getDriverList({
      name: payload,
      page: 1,
      size: 10,
    });
    if (code === 200) {
      if (data.list && data.list.length) {
        data.list.forEach(item => {
          item.label = item.name;
          item.value = item.id;
        });
      }
      context.commit('updateState', {
        key: 'driverList',
        value: data.list,
      });
    }
  },
};
// mutations
const mutations = {
  // 重置所有状态
  initFilter(state) {
    state.parameters.forEach(item => {
      if (item.isFixed) {
        return;
      }
      if (item.style !== 'date-picker' && item.value) {
        if (item.multiple && item.style !== 'input-multiple') {
          item.value = [];
        } else {
          item.value = '';
        }
      }
      if (item.style === 'date-picker') {
        item.value = [];
      }
    });
  },
  // 更新state数据
  updateState(state, { key, value }) {
    state[key] = value;
  },
  // 更新列表参数数据
  updatePostParams(state, payload) {
    state.postParams = Object.assign({}, state.postParams, payload);
  },
  // 根据index更新value
  updateValueFromIndex(state, payload) {
    state.parameters[payload.index].value = payload.value;
    // switch (state.parameters[payload.index].param) {
    //   case 'businessId':
    //     state.companyInfo = state.companyList.find(item => item.businessId === payload.value);
    //     break;
    //   default:
    //     break;
    // }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
